<template>
  <q-btn
    v-if="table && !table.$attrs.grid"
    round
    icon="fa fa-file-excel"
    v-bind="$attrs"
    style="z-index: 1"
    @click="table.download()"
  />
</template>

<script>
export default {
  name: 'BtnTableExportExcel',
  inject: {
    table: {}
  }
}
</script>

<style scoped>

</style>
